// source: acompanha/sales_channels/v1/sales_channels.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.sales_channels.v1.CreateSalesChannelRequest', null, global);
goog.exportSymbol('proto.acompanha.sales_channels.v1.CreateSalesChannelResponse', null, global);
goog.exportSymbol('proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest', null, global);
goog.exportSymbol('proto.acompanha.sales_channels.v1.ListSalesChannelsRequest', null, global);
goog.exportSymbol('proto.acompanha.sales_channels.v1.ListSalesChannelsResponse', null, global);
goog.exportSymbol('proto.acompanha.sales_channels.v1.SalesChannel', null, global);
goog.exportSymbol('proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest', null, global);
goog.exportSymbol('proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.sales_channels.v1.SalesChannel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.sales_channels.v1.SalesChannel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.sales_channels.v1.SalesChannel.displayName = 'proto.acompanha.sales_channels.v1.SalesChannel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.sales_channels.v1.ListSalesChannelsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.sales_channels.v1.ListSalesChannelsRequest.displayName = 'proto.acompanha.sales_channels.v1.ListSalesChannelsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.sales_channels.v1.ListSalesChannelsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.displayName = 'proto.acompanha.sales_channels.v1.ListSalesChannelsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.sales_channels.v1.CreateSalesChannelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.displayName = 'proto.acompanha.sales_channels.v1.CreateSalesChannelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.sales_channels.v1.CreateSalesChannelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.displayName = 'proto.acompanha.sales_channels.v1.CreateSalesChannelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.displayName = 'proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.displayName = 'proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.displayName = 'proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.sales_channels.v1.SalesChannel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.sales_channels.v1.SalesChannel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.SalesChannel.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
commissionPercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
fixedFee: jspb.Message.getFieldWithDefault(msg, 6, 0),
paymentFeePercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
dispatchDays: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
notes: jspb.Message.getFieldWithDefault(msg, 9, ""),
minFee: jspb.Message.getFieldWithDefault(msg, 10, 0),
requiresExternalOrderId: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
kind: jspb.Message.getFieldWithDefault(msg, 12, ""),
holdsPayout: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel}
 */
proto.acompanha.sales_channels.v1.SalesChannel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.sales_channels.v1.SalesChannel;
  return proto.acompanha.sales_channels.v1.SalesChannel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.sales_channels.v1.SalesChannel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel}
 */
proto.acompanha.sales_channels.v1.SalesChannel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommissionPercent(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFixedFee(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPaymentFeePercent(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDispatchDays(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinFee(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequiresExternalOrderId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setKind(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHoldsPayout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.sales_channels.v1.SalesChannel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.sales_channels.v1.SalesChannel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.SalesChannel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCommissionPercent();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getFixedFee();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getPaymentFeePercent();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMinFee();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getRequiresExternalOrderId();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getKind();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getHoldsPayout();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
*/
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
*/
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional double commission_percent = 5;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getCommissionPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setCommissionPercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int64 fixed_fee = 6;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getFixedFee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setFixedFee = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double payment_fee_percent = 7;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getPaymentFeePercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setPaymentFeePercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional int32 dispatch_days = 8;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getDispatchDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setDispatchDays = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.clearDispatchDays = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.hasDispatchDays = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string notes = 9;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 min_fee = 10;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getMinFee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setMinFee = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional bool requires_external_order_id = 11;
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getRequiresExternalOrderId = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setRequiresExternalOrderId = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string kind = 12;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setKind = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool holds_payout = 13;
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.getHoldsPayout = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel} returns this
 */
proto.acompanha.sales_channels.v1.SalesChannel.prototype.setHoldsPayout = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.sales_channels.v1.ListSalesChannelsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.sales_channels.v1.ListSalesChannelsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.sales_channels.v1.ListSalesChannelsRequest}
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.sales_channels.v1.ListSalesChannelsRequest;
  return proto.acompanha.sales_channels.v1.ListSalesChannelsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.sales_channels.v1.ListSalesChannelsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.sales_channels.v1.ListSalesChannelsRequest}
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.sales_channels.v1.ListSalesChannelsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.sales_channels.v1.ListSalesChannelsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.sales_channels.v1.ListSalesChannelsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
channelsList: jspb.Message.toObjectList(msg.getChannelsList(),
    proto.acompanha.sales_channels.v1.SalesChannel.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.sales_channels.v1.ListSalesChannelsResponse}
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.sales_channels.v1.ListSalesChannelsResponse;
  return proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.sales_channels.v1.ListSalesChannelsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.sales_channels.v1.ListSalesChannelsResponse}
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.sales_channels.v1.SalesChannel;
      reader.readMessage(value,proto.acompanha.sales_channels.v1.SalesChannel.deserializeBinaryFromReader);
      msg.addChannels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.sales_channels.v1.ListSalesChannelsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.sales_channels.v1.SalesChannel.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SalesChannel channels = 1;
 * @return {!Array<!proto.acompanha.sales_channels.v1.SalesChannel>}
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.prototype.getChannelsList = function() {
  return /** @type{!Array<!proto.acompanha.sales_channels.v1.SalesChannel>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.sales_channels.v1.SalesChannel, 1));
};


/**
 * @param {!Array<!proto.acompanha.sales_channels.v1.SalesChannel>} value
 * @return {!proto.acompanha.sales_channels.v1.ListSalesChannelsResponse} returns this
*/
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.prototype.setChannelsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.sales_channels.v1.SalesChannel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.sales_channels.v1.SalesChannel}
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.prototype.addChannels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.sales_channels.v1.SalesChannel, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.sales_channels.v1.ListSalesChannelsResponse} returns this
 */
proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.prototype.clearChannelsList = function() {
  return this.setChannelsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
commissionPercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
fixedFee: jspb.Message.getFieldWithDefault(msg, 3, 0),
paymentFeePercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
dispatchDays: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
notes: jspb.Message.getFieldWithDefault(msg, 6, ""),
minFee: jspb.Message.getFieldWithDefault(msg, 7, 0),
requiresExternalOrderId: (f = jspb.Message.getBooleanField(msg, 8)) == null ? undefined : f,
kind: (f = jspb.Message.getField(msg, 9)) == null ? undefined : f,
holdsPayout: (f = jspb.Message.getBooleanField(msg, 10)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.sales_channels.v1.CreateSalesChannelRequest;
  return proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommissionPercent(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFixedFee(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPaymentFeePercent(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDispatchDays(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinFee(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequiresExternalOrderId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setKind(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHoldsPayout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCommissionPercent();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getFixedFee();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getPaymentFeePercent();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMinFee();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBool(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double commission_percent = 2;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.getCommissionPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.setCommissionPercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional int64 fixed_fee = 3;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.getFixedFee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.setFixedFee = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional double payment_fee_percent = 4;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.getPaymentFeePercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.setPaymentFeePercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional int32 dispatch_days = 5;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.getDispatchDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.setDispatchDays = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.clearDispatchDays = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.hasDispatchDays = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string notes = 6;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 min_fee = 7;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.getMinFee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.setMinFee = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional bool requires_external_order_id = 8;
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.getRequiresExternalOrderId = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.setRequiresExternalOrderId = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.clearRequiresExternalOrderId = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.hasRequiresExternalOrderId = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string kind = 9;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.getKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.setKind = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.clearKind = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.hasKind = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool holds_payout = 10;
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.getHoldsPayout = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.setHoldsPayout = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.clearHoldsPayout = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelRequest.prototype.hasHoldsPayout = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.sales_channels.v1.CreateSalesChannelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.sales_channels.v1.SalesChannel.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelResponse}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.sales_channels.v1.CreateSalesChannelResponse;
  return proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.sales_channels.v1.CreateSalesChannelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelResponse}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.sales_channels.v1.SalesChannel;
      reader.readMessage(value,proto.acompanha.sales_channels.v1.SalesChannel.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.sales_channels.v1.CreateSalesChannelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.sales_channels.v1.SalesChannel.serializeBinaryToWriter
    );
  }
};


/**
 * optional SalesChannel data = 1;
 * @return {?proto.acompanha.sales_channels.v1.SalesChannel}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.sales_channels.v1.SalesChannel} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.sales_channels.v1.SalesChannel, 1));
};


/**
 * @param {?proto.acompanha.sales_channels.v1.SalesChannel|undefined} value
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelResponse} returns this
*/
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.CreateSalesChannelResponse} returns this
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
commissionPercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
fixedFee: jspb.Message.getFieldWithDefault(msg, 4, 0),
paymentFeePercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
dispatchDays: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
notes: jspb.Message.getFieldWithDefault(msg, 7, ""),
minFee: jspb.Message.getFieldWithDefault(msg, 8, 0),
requiresExternalOrderId: (f = jspb.Message.getBooleanField(msg, 9)) == null ? undefined : f,
kind: (f = jspb.Message.getField(msg, 10)) == null ? undefined : f,
holdsPayout: (f = jspb.Message.getBooleanField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest;
  return proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCommissionPercent(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFixedFee(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPaymentFeePercent(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDispatchDays(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotes(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinFee(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequiresExternalOrderId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setKind(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHoldsPayout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCommissionPercent();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getFixedFee();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPaymentFeePercent();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMinFee();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeBool(
      9,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double commission_percent = 3;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getCommissionPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setCommissionPercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int64 fixed_fee = 4;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getFixedFee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setFixedFee = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double payment_fee_percent = 5;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getPaymentFeePercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setPaymentFeePercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional int32 dispatch_days = 6;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getDispatchDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setDispatchDays = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.clearDispatchDays = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.hasDispatchDays = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string notes = 7;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 min_fee = 8;
 * @return {number}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getMinFee = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setMinFee = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional bool requires_external_order_id = 9;
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getRequiresExternalOrderId = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setRequiresExternalOrderId = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.clearRequiresExternalOrderId = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.hasRequiresExternalOrderId = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string kind = 10;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getKind = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setKind = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.clearKind = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.hasKind = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool holds_payout = 11;
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.getHoldsPayout = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.setHoldsPayout = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.clearHoldsPayout = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest.prototype.hasHoldsPayout = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.sales_channels.v1.SalesChannel.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse;
  return proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.sales_channels.v1.SalesChannel;
      reader.readMessage(value,proto.acompanha.sales_channels.v1.SalesChannel.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.sales_channels.v1.SalesChannel.serializeBinaryToWriter
    );
  }
};


/**
 * optional SalesChannel data = 1;
 * @return {?proto.acompanha.sales_channels.v1.SalesChannel}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.sales_channels.v1.SalesChannel} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.sales_channels.v1.SalesChannel, 1));
};


/**
 * @param {?proto.acompanha.sales_channels.v1.SalesChannel|undefined} value
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse} returns this
*/
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse} returns this
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest}
 */
proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest;
  return proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest}
 */
proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest} returns this
 */
proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.sales_channels.v1);
